import React from "react";
import { Routes, Route } from "react-router-dom";
import NewApplications from "../NewApplications/Pages/NewApplications"
import ShortlistCandidates from "../ShortlistedCandidate/Pages/ShortlistedCandidates";
import InterviewScheduledApplication from "../InterviewScheduled/Pages/InterviewScheduledApplication";
import AssessmentCandidates from "../AssessmentCandidates/Pages/AssessmentCandidates";
import SelectedCandidates from "../SelectedCandidates/Pages/SelectedCandidates";
import OfferReleasedCandidates from "../OfferReleasedCandidates/Pages/OfferReleasedCandidates";
import HiredCandidates from "../HiredCandidates/Pages/HiredCandidates";
import RejectedCandidates from "../RejectedCandidates/Pages/RejectedCandidates";
import BackoutCandidates from "../BackoutCandidates/Pages/BackoutCandidates";
import HoldCandidates from "../HoldCandidates/Pages/HoldCandidates";
import BGVCandidates from "../BGVCandidates/Pages/BGVCandidates";


const CandidateRoute = () => {
  return (
    <Routes>
      
        <Route path="New-Applications" element={<NewApplications />} />
        <Route path="Shortlist-Candidates" element={<ShortlistCandidates />} />
        <Route path="Interview-Scheduled" element={<InterviewScheduledApplication />} />
        <Route path="Assessment-Candidates" element={<AssessmentCandidates />} />
        <Route path="Get-Selected-Candidates" element={<SelectedCandidates />} />
        <Route path="Offer-Released-Candidate" element={<OfferReleasedCandidates />} />
        <Route path="Hired-Candidates" element={<HiredCandidates />} />
        <Route path="Rejected-Candidates" element={<RejectedCandidates />} />
        <Route path="Backout-Candidates" element={<BackoutCandidates />} />
        <Route path="Hold-Candidates" element={<HoldCandidates />} />
        <Route path="BGV-Candidates" element={<BGVCandidates />} />
    </Routes>
  );
};

export default CandidateRoute;
